export function reverseAriaExpanded(element, expand) {
    if (expand === undefined) {
        expand = element.getAttribute('aria-expanded') === 'false';
    }

    element.setAttribute('aria-expanded', expand);
}

// Based on https://hidde.blog/using-javascript-to-trap-focus-in-an-element/
export class FocusTrap {
    constructor(element, focusableEls) {
        this.element = element;
        this.focusableEls = focusableEls ?? this.constructor.getFocusableEls(element);
        this.firstFocusableEl = this.focusableEls[0];
        this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
        this._handler = this._handleKeydown.bind(this);
    }

    static getFocusableEls(element) {
        return element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    }

    enable() {
        document.addEventListener('keydown', this._handler);
    }

    disable() {
        document.removeEventListener('keydown', this._handler);
    }

    _handleKeydown(e) {
        if (!(e.key === 'Tab' || e.keyCode === 9)) { 
            return; 
        }

        if ( e.shiftKey ) /* shift + tab */ {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        } else /* tab */ {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    }
}